// src/components/Services.jsx
import React, { useState } from 'react';

const services = [
  { icon: '🧑', name: 'Individual Counseling' },
  { icon: '👨‍👩‍👧', name: 'Family Counseling' },
  { icon: '💑', name: 'Couple / Relationship Counseling' },
  { icon: '💍', name: 'Marriage & Pre-Marital Counseling' },
  { icon: '🧒', name: 'Children & Adolescent Counseling' },
  { icon: '👪', name: 'Parenting Guidance Counseling' },
  { icon: '🧘', name: 'Stress Management Counseling' },
  { icon: '💭', name: 'Anxiety & Depression Counseling' },
  { icon: '😤', name: 'Anger Management Counseling' },
  { icon: '🌟', name: 'Personality Development Counseling' },
  { icon: '❤️', name: 'Emotional & Behavioral Counseling' },
  { icon: '📚', name: 'Study Management & Student Counseling' },
  { icon: '🎓', name: 'Career Guidance Counseling' },
  { icon: '🧩', name: 'Learning Disability Counseling' },
  { icon: '🚭', name: 'Addiction / Substance Abuse Counseling' },
  { icon: '💚', name: 'Mental Health Awareness & Wellness Support' },
  { icon: '👥', name: 'Group Counseling Sessions' },
  { icon: '🏅', name: 'Confidence & Self-Esteem Building' },
  { icon: '🌈', name: 'Psychological Guidance for Life Challenges' },
  { icon: '🧠', name: 'Mind Relaxation & Emotional Well-being Sessions' },
];

const ServiceCard = ({ icon, name, index }) => {
  const [hovered, setHovered] = useState(false);
  const delay = (index % 4) * 100;

  return (
    <div
      style={styles.card(hovered)}
      data-aos="fade-up"
      data-aos-delay={delay}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={styles.iconCircle(hovered)}>{icon}</div>
      <p style={styles.name(hovered)}>{name}</p>
    </div>
  );
};

const Services = () => {
  return (
    <section id="services" className="viha-section" style={styles.section}>
      <div style={styles.container}>
        <div style={styles.header}>
          <span className="section-badge">What We Offer</span>
          <h2 style={styles.title}>Comprehensive Mental Health Services</h2>
          <p style={styles.subtitle}>Caring for Your Mind, Supporting Your Life.</p>
        </div>

        <div style={styles.grid}>
          {services.map((svc, i) => (
            <ServiceCard key={svc.name} {...svc} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#D6E8F7',
  },
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 24px',
  },
  header: {
    textAlign: 'center',
    marginBottom: 52,
  },
  title: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(24px, 3.5vw, 36px)',
    color: '#1B3F6E',
    marginTop: 8,
    marginBottom: 12,
  },
  subtitle: {
    fontSize: 17,
    color: '#6C757D',
    maxWidth: 480,
    margin: '0 auto',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: 24,
  },
  card: (hovered) => ({
    backgroundColor: '#ffffff',
    borderRadius: 16,
    padding: '28px 20px 24px',
    textAlign: 'center',
    boxShadow: hovered
      ? '0 12px 36px rgba(27,63,110,0.16)'
      : '0 4px 16px rgba(27,63,110,0.08)',
    transform: hovered ? 'translateY(-6px)' : 'translateY(0)',
    transition: 'all 0.28s ease',
    borderTop: hovered ? '4px solid #5A9E4B' : '4px solid transparent',
    cursor: 'default',
  }),
  iconCircle: (hovered) => ({
    width: 56,
    height: 56,
    borderRadius: '50%',
    backgroundColor: hovered ? '#5A9E4B' : '#E8F5E2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 26,
    margin: '0 auto 16px',
    transition: 'all 0.28s ease',
  }),
  name: (hovered) => ({
    fontFamily: "'Lato', sans-serif",
    fontSize: 14,
    fontWeight: 700,
    color: hovered ? '#5A9E4B' : '#1B3F6E',
    lineHeight: 1.4,
    margin: 0,
    transition: 'color 0.28s ease',
  }),
};

export default Services;
